module.exports = {
          srcSet: __webpack_public_path__ + "images/1917-e163c22a8676d7559b7ceec81c9bbfca-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1917-9bc315f21d95172e4cbab15a92f22e4b-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1917-e163c22a8676d7559b7ceec81c9bbfca-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1917-9bc315f21d95172e4cbab15a92f22e4b-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1917-e163c22a8676d7559b7ceec81c9bbfca-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1917-e163c22a8676d7559b7ceec81c9bbfca-320.jpg"},
          
          width: 320,
          height: 251
        }